var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from "vue-class-component";
import GlobalVue from "../globalVue";
import { Prop } from 'vue-property-decorator';
import { createTab } from "../helper/util";
import { mapActions } from "vuex";
import { preAuthCode } from "../constant/prefix";
import { authNameCodeDict } from '../biz/AuthBiz';
import { getExcludeModules } from '../helper/authDecorator';
import GLOBAL_VUE from '../globalVue';
var PREFIX = "bTabs_";
var TOP = 95;
var Tab = (function (_super) {
    __extends(Tab, _super);
    function Tab() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.current = "";
        _this.menuShow = false;
        _this.idList = [];
        _this.height = 0;
        _this.tabArr = [];
        return _this;
    }
    Tab.prototype.created = function () {
        if (this.global) {
            GlobalVue.$on("addTab", this.addTab);
            GlobalVue.$on("closeTab", this.closeTab);
        }
        this.height = document.documentElement.clientHeight - TOP;
    };
    Tab.prototype.addTab = function (props) {
        var _this = this;
        if (!props.name) {
            throw new Error("弹出的标签属性name不能为空！");
        }
        var result = {};
        var existTab = this.tabArr.find(function (item) {
            return item.name === props.name;
        });
        GlobalVue.$emit('resetTable');
        var promise;
        if (props.showExist && existTab && props.title !== '编辑模板') {
            result = existTab;
            promise = Promise.resolve();
        }
        else {
            var hasOwnAuth_1 = false;
            var excludeModules_1 = getExcludeModules();
            if (props.component[preAuthCode]) {
                hasOwnAuth_1 = true;
                promise = this.getAuth(props.component[preAuthCode]);
            }
            else {
                promise = Promise.resolve();
            }
            promise.then(function (auth) {
                if (auth) {
                    var res = auth.Response;
                    var hasLookDetail = (res.all_power_key || []).some(function (item) { return item === authNameCodeDict.LookDetail; });
                    props.cprops.Root_PageAuth = auth.Auth;
                    props.cprops.root_PageAuth$$ = auth.Auth;
                    if (hasLookDetail && !auth.Auth.LookDetail && excludeModules_1.indexOf(props.component) === -1) {
                        _this.$message.error("暂无查看权限");
                        return;
                    }
                }
                else if (hasOwnAuth_1) {
                    _this.$message.error("暂无查看权限");
                    return;
                }
                result = createTab(props.component, __assign({ opener: props.opener }, props.cprops));
                result.name = props.name;
                _this.tabArr.push(result);
            });
        }
        promise.then(function (res) {
            var handleClick = function () {
                GLOBAL_VUE.$emit('tabClick', {
                    id: result.id,
                    title: props.title,
                    result: result.dom
                });
            };
            _this.idList = $(_this.$refs.tabContainer).bTabsAdd(result.id, props.title, result.dom, {}, handleClick).data('bTabs').openTabs;
            props.callback && props.callback(result);
        });
    };
    Tab.prototype.closeTab = function (component) {
        var el = component.$el;
        var current = this.tabArr.find(function (item) { return item.dom === el.parentElement; });
        if (current) {
            var $con = $(this.$refs.tabContainer).data('bTabs');
            $con.closeTab(current.id.replace("TAB_FLAG", "bTabs_TAB_FLAG"));
        }
        var opener = component.opener;
        if (!opener) {
            return;
        }
        var parentElement = opener.$el.parentElement;
        var openerParent = this.tabArr.find(function (item) { return item.dom === parentElement; });
        while (!openerParent && parentElement.parentElement) {
            openerParent = this.tabArr.find(function (item) { return item.dom === parentElement.parentElement; });
            parentElement = parentElement.parentElement;
        }
        if (openerParent) {
            $(this.$refs.tabContainer).bTabsAdd(openerParent.id, "新打开页面", {}, undefined, function () {
                GLOBAL_VUE.$emit('tabClick', {
                    id: openerParent.id,
                    title: '新打开页面',
                    dom: {}
                });
            });
        }
    };
    Tab.prototype.closeCurrent = function () {
        var $con = $(this.$refs.tabContainer).data('bTabs');
        $con.closeTab(this.current);
        this.current = "";
        this.menuShow = false;
    };
    Tab.prototype.closeOther = function () {
        var _this = this;
        var $con = $(this.$refs.tabContainer).data('bTabs');
        var list = $.extend([], this.idList);
        list.forEach(function (item) {
            if (item !== _this.current) {
                $con.closeTab(item);
            }
        });
        this.idList = [this.current];
        this.current = "";
        this.menuShow = false;
    };
    Tab.prototype.getTabId = function ($dom) {
        return $dom.attr('href').replace('#', '');
    };
    Tab.prototype.closeAll = function () {
        var $con = $(this.$refs.tabContainer).data('bTabs');
        var list = $.extend([], this.idList);
        list.forEach(function (item) {
            $con.closeTab(item);
        });
        this.idList = [];
        this.menuShow = false;
        this.$emit('tabClose');
    };
    Tab.prototype.destroyed = function () {
        if (this.global) {
            GlobalVue.$off("addTab", this.addTab);
        }
        $(window).off("click", this.menuHide);
    };
    Tab.prototype.removeTab = function (event, id) {
        var index = this.tabArr.findIndex(function (item) { return (PREFIX + item.id) === id; });
        if (index > -1) {
            this.tabArr.splice(index, 1);
            this.$emit('tabClose');
        }
        var idList = $(this.$refs.tabContainer).data("bTabs").openTabs, activeTabNum = $(this.$refs.tabContainer).find(".tab-pane.active").length;
        if (idList.length > 0 && activeTabNum === 0) {
            $('#' + idList[0]).addClass('active');
            $('a[href=#' + idList[0] + ']').parent().addClass('active');
        }
    };
    Tab.prototype.getTabs = function () {
        return this.idList;
    };
    Tab.prototype.mounted = function () {
        var _this = this;
        this.idList = $(this.$refs.tabContainer).bTabs().data("bTabs").openTabs;
        $(this.$refs.tabContainer).find(".nav-tabs").on("contextmenu", "a", function (e) {
            e.preventDefault();
            if (!$(e.currentTarget).parent().hasClass("active")) {
                return;
            }
            _this.current = _this.getTabId($(e.currentTarget));
            var menuRef = _this.$refs.tabMenu;
            var target = e.currentTarget.parentElement;
            if (target) {
                menuRef.style.top = (target.offsetHeight - 10) + "px";
                menuRef.style.left = (target.offsetLeft + 20) + "px";
                _this.menuShow = true;
            }
        });
        $(window).on("click", this.menuHide);
        $(this.$refs.tabContainer).on("tab.close", this.removeTab);
    };
    Tab.prototype.menuHide = function () {
        this.menuShow = false;
    };
    __decorate([
        Prop({
            default: true,
            type: Boolean
        })
    ], Tab.prototype, "global", void 0);
    Tab = __decorate([
        Component({
            methods: __assign({}, mapActions(["getAuth"]))
        })
    ], Tab);
    return Tab;
}(Vue));
export default Tab;
